export default __webpack_public_path__ + "static/media/pictogramPrint64.46aefce0.svg";